<template>
  <div
      :id="schema.ref"
      :class="clz"
      :style="style"
      ref="container"
      class="spreadsheet"
  >
    <TableSheet
        @cornerCellClick="cornerCellClick"
        @colCellClick="colCellClick"
        @rowCellClick="rowCellClick"
        @dataCellClick="dataCellClick"
        v-if="!refresh"
        ref="sheet"
        :dataCfg="dataCfg"
        :themeCfg="themeCfg"
        :options="options"
        :adaptive="{ width: true, height: false }"
        :sheetType="isBasic ? '' : 'table'"
    />
    <!--		<SheetComponent-->
    <!--			:partDrillDown="PartDrillDown"-->
    <!--			v-if="!refresh"-->
    <!--			ref="sheet"-->
    <!--			:dataCfg="dataCfg"-->
    <!--			:themeCfg="themeCfg"-->
    <!--			:options="options"-->
    <!--			:sheetType="isBasic ? '' : 'table'"-->
    <!--		/>-->
    <ChartNav :currentDrillRouteIndex="-1" @multiJump="thisArg.multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='props.schema.prop'
              :option="props.schema.option"
              :drillClickList="[]" :drillDimList="[]"></ChartNav>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>
<script setup>
import {Image as GImage, Polygon, Polyline, Rect} from '@antv/g';
import ChartNav from '@/components/drillNav.vue'
import {deepClone} from '@/echart/util'
import {useRender} from "@/option/components/useRender";
import {useCommonMix} from "@/option/common/commonmix";
import {
  computed,
  createVNode,
  inject,
  nextTick,
  onMounted, reactive,
  ref,
  render,
  shallowRef,
  unref,
  useAttrs,
  watch,
  watchEffect,
} from "vue";
import util from "@/option/common/util";
import {SheetComponent, TableSheet} from "@antv/s2-vue";
import "@antv/s2-vue/dist/style.min.css";
import {useDebounceFn, useEventBus, useEventListener} from "@vueuse/core";
import request from "@/option/common/lowCodeRequest.js";
import {
  DATA_SOURCE_TYPE,
  EVENT_TYPE,
  OPEN_PAGE_TYPE,
  SPREAD_SHEET_TYPE,
} from "@/option/common/dict.js";
import {generatePalette, getPalette, getTheme, BaseTooltip, DataCell, ColCell, drawCustomContent} from "@antv/s2";
import SheetTooltip from "./sheetTooltip.vue";
import {cloneDeep, uniq, orderBy} from "lodash-es";
import {placeholderSign} from 'element-plus/es/components/table-v2/src/private';
import rank1Icon from '@/assets/svgs/range-1.svg'
import rank2Icon from '@/assets/svgs/range-2.svg'
import rank3Icon from '@/assets/svgs/range-3.svg'
import rank4Icon from '@/assets/svgs/range-4.svg'

let sheet = ref();
let container = ref();
const emit = defineEmits(["select"]);
let attrs = useAttrs();
let _originAttr = {...attrs};
delete _originAttr.style;
delete _originAttr.id;
let attr = _originAttr;
// isDataCenter 判断是否配置了指标维度
const props = defineProps(['thisArg', "class", "config", "schema", "select", "dataChart", 'isDataCenter', 'multiJump']);
const {confirm, success, warning, error} = useCommonMix();
let {handleSchemaSelect, clz, createNode} = useRender(emit, props);
let pageParam = inject("rootPageArgs", {});

let style = computed(() => {
  return {
    ...attrs.style,
  };
});
// let isDrill = computed(() => {
// 	return;
// });
// 是否为基础透视表 有两种 基础透视表 基础明细表
let isBasic = computed(() => {
  return props.schema.prop.spreadSheetType === SPREAD_SHEET_TYPE.BASIC;
});

let themeConfig = computed(() => {
  console.log()
  return props.schema.themeCfg;
})
let isDark = computed(() => {
  return themeCfg.value?.colorType === 'deep_color'
})
const cellTheme = {
  cell: {
    verticalBorderColorOpacity: 1,
    horizontalBorderColorOpacity: 1,
  },
};

const opacityCellTheme = {
  verticalBorderColorOpacity: 0,
  horizontalBorderColorOpacity: 0,
  interactionState: {
    hoverFocus: {
      borderColor: 'transparent',
      borderOpacity: 0
    }
  },
};

let themeCfg = computed(() => {
  let _themecfg = {name: "gray", theme: {}};

  let cfg = props.schema.prop;
  // let originTheme = getTheme(theme.name)
  if (cfg.themeColor || themeConfig.value?.sheetSet.themeColor) {
    // 使用内置的 colorful 色板作为参考色板
    const palette = getPalette(_themecfg.name);
    // 使用参考色板 & 主题色值生成新色板
    const newPalette = generatePalette({
      ...palette,
      brandColor: cfg.themeColor || themeConfig.value?.sheetSet.themeColor,
    });
    // 使用新色板设置主题
    _themecfg.name = _themecfg.name;
    _themecfg.palette = newPalette;
  }
  if (cfg?.theme?.colCell.cell.shadow) {
    _themecfg.theme.splitLine = {
      ...opacityCellTheme,
      horizontalBorderWidth: 2,
      shadowColors: {
        left: 'rgba(255,255,255, 0)',
        right: 'rgba(255,255,255, 0)',
      },
    }
  }
  const themeCellContent = themeConfig.value?.sheetSet?.cellContent;
  const themeHeadContent = themeConfig.value?.sheetSet?.headContent;
  // 这些玩意底下都是对象，最好解构赋值，不然容易互相覆盖
  if (cfg?.theme?.dataCell) {
    _themecfg.theme.dataCell = {
      ...cfg?.theme?.dataCell,
      text: {
        ...cfg?.theme?.dataCell.text,
        fontSize: (cfg?.theme?.dataCell?.text?.fontSize || themeCellContent?.size) || 12,
        fill: (cfg?.theme?.dataCell?.text?.fill || themeCellContent?.color) || '#333333',
      }
    };
  }
  if (cfg?.theme?.rowCell) {
    _themecfg.theme.rowCell = {...cfg?.theme?.rowCell};
    _themecfg.theme.rowCell.bolderText = {...cfg?.theme?.rowCell.text};
    _themecfg.theme.rowCell.measureText = {...cfg?.theme?.rowCell.text};
  }
  if (cfg?.theme?.colCell) {
    _themecfg.theme.colCell = {
      ...cfg?.theme?.colCell,
      text: {
        ...cfg?.theme?.colCell.text,
        fontSize: (cfg?.theme?.colCell?.text?.fontSize || themeHeadContent?.size) || 12,
        fill: (cfg?.theme?.colCell?.text?.fill || themeHeadContent?.color) || '#333333',
      }
    };
    _themecfg.theme.colCell.bolderText = {
      ...cfg?.theme?.colCell.text,
      fontSize: (cfg?.theme?.colCell?.text?.fontSize || themeHeadContent?.size) || 12,
      fill: (cfg?.theme?.colCell?.text?.fill || themeHeadContent?.color) || '#333333',
    };
    _themecfg.theme.colCell.measureText = {
      ...cfg?.theme?.colCell.text,
      fontSize: (cfg?.theme?.colCell?.text?.fontSize || themeHeadContent?.size) || 12,
      fill: (cfg?.theme?.colCell?.text?.fill || themeHeadContent?.color) || '#333333',
    };
  }
  if (cfg?.theme?.cornerCell) {
    _themecfg.theme.cornerCell = {
      ...cfg?.theme?.cornerCell,
      text: {
        ...cfg?.theme?.cornerCell.text,
        fontSize: (cfg?.theme?.cornerCell?.text?.fontSize || themeHeadContent?.size) || 12,
        fill: (cfg?.theme?.cornerCell?.text?.fill || themeHeadContent?.color) || '#333333',
      }
    };
    _themecfg.theme.cornerCell.bolderText = {
      ...cfg?.theme?.cornerCell.text,
      fontSize: (cfg?.theme?.cornerCell?.text?.fontSize || themeHeadContent?.size) || 12,
      fill: (cfg?.theme?.cornerCell?.text?.fill || themeHeadContent?.color) || '#333333',
    };
    _themecfg.theme.cornerCell.measureText = {
      ...cfg?.theme?.cornerCell.text,
      fontSize: (cfg?.theme?.cornerCell?.text?.fontSize || themeHeadContent?.size) || 12,
      fill: (cfg?.theme?.cornerCell?.text?.fill || themeHeadContent?.color) || '#333333',
    };
  }
  if (cfg.isTransparent && cfg?.theme?.colCell && cfg?.theme?.rowCell && cfg?.theme?.cornerCell && cfg?.theme?.dataCell) {
    _themecfg.theme.background = {
      ..._themecfg.theme?.background,
      opacity: 0,
    }
    _themecfg.theme.colCell.cell = {
      ..._themecfg.theme?.colCell?.cell,
      backgroundColorOpacity: 0,
    }
    _themecfg.theme.rowCell.cell = {
      ..._themecfg.theme?.rowCell?.cell,
      backgroundColorOpacity: 0,
    }
    _themecfg.theme.dataCell.cell = {
      ..._themecfg.theme?.dataCell?.cell,
      backgroundColorOpacity: 0,
    }
    _themecfg.theme.cornerCell.cell = {
      ..._themecfg.theme?.cornerCell?.cell,
      backgroundColorOpacity: 0,
    }
  } else if (cfg?.theme?.colCell && cfg?.theme?.rowCell && cfg?.theme?.cornerCell && cfg?.theme?.dataCell) {
    _themecfg.theme.background = {
      ..._themecfg.theme?.background,
      opacity: 1,
    }
    _themecfg.theme.colCell.cell = {
      ..._themecfg.theme?.colCell?.cell,
      backgroundColorOpacity: 1,
    }
    _themecfg.theme.rowCell.cell = {
      ..._themecfg.theme?.rowCell?.cell,
      backgroundColorOpacity: 1,
    }
    _themecfg.theme.dataCell.cell = {
      ..._themecfg.theme?.dataCell?.cell,
      backgroundColorOpacity: 1,
    }
    _themecfg.theme.cornerCell.cell = {
      ..._themecfg.theme?.cornerCell?.cell,
      backgroundColorOpacity: 1,
    }
  }
  return _themecfg;
});

function clearDeep(obj) {
  if (!obj || !typeof obj === "object") return;
  const keys = Object.keys(obj);
  for (var key of keys) {
    const val = obj[key];
    if (val == undefined || !val) {
      // 如属性值为null或undefined或''，则将该属性删除
      delete obj[key];
    } else if (typeof val === "object") {
      // 属性值为对象，递归调用
      clearDeep(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        // 如某属性的值为不包含任何属性的独享，则将该属性删除
        delete obj[key];
      }
    }
  }
}

let options = ref();
let data = ref([]);

function cornerCellClick(d) {
  cellClickHandler(d)
}

const multiActionsParam = ref({
  clickParams: {
    offsetX: 0,
    offsetY: 0
  },
  // 显示多路径下钻等浮层
  showMultiAction: false,
  themeCfg: themeConfig.value
})
const drillIndex = ref(-1)

function setPosition(e) {
  multiActionsParam.value.clickParams.offsetX = e.event.x
  multiActionsParam.value.clickParams.offsetY = e.event.y
  multiActionsParam.value.showMultiAction = true
}

function setCurrentData(v) {
  props.thisArg.currentClickItem = v
}

function rowCellClick(d) {
  props.thisArg.setDisableRequest()
  setPosition(d)
  // 基础透视表才走这里
  if (!unref(isBasic)) return;
  // 可能会有多条数据 默认取第一条
  let rowData = sheet.value.instance.dataSet.getMultiData(d.viewMeta.query)[0];
  setCurrentData(rowData)
  props.thisArg.generateJumpFilterData({
    ...rowData,
    code: d.viewMeta.field,
  })
  setLinkData(rowData)
  cellClickHandler(rowData)

}

function colCellClick(d) {
  props.thisArg.setDisableRequest()
  console.log("cl", d);
  cellClickHandler(d)
  // setPosition(d)
  // // 基础透视表才走这里
  // if (!unref(isBasic)) return;
  // // 可能会有多条数据 默认取第一条
  // let data = {
  //   [d.viewMeta?.field]: d.viewMeta?.value,
  //   [`_${d.viewMeta?.field}`]: d.viewMeta?.value
  // }
  // props.thisArg.generateJumpFilterData({
  //   ...data,
  //   code: d.viewMeta.field,
  // })
  // setLinkData(data)
}

function dataCellClick(d) {
  props.thisArg.setDisableRequest()
  setPosition(d)
  let v;
  if (unref(isBasic)) {
    // 获取当前行数据 透视表这样获取数据 vue版本的文档没写清楚 找了半天
    let rowData = sheet.value.instance.dataSet.getMultiData({
      ...d.viewMeta.colQuery,
      ...d.viewMeta.rowQuery,
    })[0];
    v = {
      ...rowData,
      code: d.viewMeta?.valueField,
    }
    setCurrentData(v)
    props.thisArg.generateJumpFilterData(v)
    setLinkData(rowData)
  } else {
    let meta = d.viewMeta;
    let item = unref(data)[meta.rowIndex];
    v = {
      ...item,
      code: meta.valueField
    }
    setCurrentData(v)
    props.thisArg.generateJumpFilterData(v)
    setLinkData(item)
  }
  cellClickHandler(v)
}

function cellClickHandler(v) {
  props.thisArg.setDisableRequest()
  let funString = props.schema.prop.config.style.cellCfg.clickHandler
  if (funString) {
    let func
    try {
      func = eval(`(${funString})`)
    } catch (e) {
      console.log(e)
    }
    func({
      dataChart: v,
      option: props
    })
  }
}

function groupHead(meta) {
  let gMap = {};
  let list = [];
  let c = props.schema.prop?.columns
  c.forEach((el) => {
    let gEl = {
      field: el.code || el.fieldCode,
      title: el.name || el.fieldName
    }
    if (el?.set?.columnGroupKey) {
      if (!gMap[el?.set?.columnGroupKey]) {
        gMap[el?.set?.columnGroupKey] = [];
      }
      gMap[el?.set?.columnGroupKey].push(gEl);
    } else {
      gMap[gEl.field] = gEl;
    }
  });
  for (const cKey in gMap) {
    let _el = gMap[cKey]
    if (Array.isArray(_el)) {
      list.push({
        field: cKey,
        title: cKey,
        children: _el,
      })
    } else {
      list.push(_el)
    }
  }
  return list;
}

function setLinkData(item) {
  if (!item) return;
  for (const currentLinkDataKey in props.thisArg.currentLinkData) {
    // 不是name的key全部赋值为当前点击的数据源
    if (currentLinkDataKey !== 'name') {
      // 这里需要处理是否为维度，因为维度前台处理加了单位 传值需要去掉单位给后台 怎么样？ 要是阁下做这个需求准备如何应对？
      // 这个标记是处理保留原始值的标记比如 2023 前台处理成 2023年 _year = 2023    year=2023年
      if (item && `_${currentLinkDataKey}` in item) {
        props.thisArg.currentLinkData[currentLinkDataKey].value = item[`_${currentLinkDataKey}`]
      }
    }
  }
}

let dataCfg = computed(() => {
  let dMeta =
      props.schema.prop?.rows?.map((el) => ({
        field: el.code,
        name: el.name,
      })) || [];
  let mMeta =
      props.schema.prop?.columns?.map((el) => ({
        field: el.code,
        name: el.name,
      })) || [];
  let vMeta =
      props.schema.prop?.metrics?.map((el) => ({
        field: el.code,
        name: el.name,
      })) || [];
  let meta = dMeta.concat(mMeta).concat(vMeta);
  let fields = {};
  let sortParams = [];
  if (isBasic.value) {
    fields = {
      rows: props.isDataCenter ? props.schema.prop?.rows?.map((el) => el.code) : props.dataChart.rows,
      columns: props.isDataCenter ? props.schema.prop?.columns?.map((el) => el.code) : props.dataChart.columns,
      values: props.isDataCenter ? props.schema.prop?.metrics?.map((el) => el.code) : props.dataChart.values,
      valueInCols: true,
    };
  } else {
    fields = {
      columns: props.isDataCenter ? groupHead(meta) : props.dataChart.columns,
    };
    sortParams = props.isDataCenter ? props.schema.prop?.columns?.map(metItem => {
      return {
        sortFieldId: metItem.code,
        sortFunc: ({data, sortFieldId, sortMethod}) => {
          // 值为--的数据放在尾部
          const rearList = data.filter(item => item[sortFieldId] === '-' || item[sortFieldId] === '--') || []
          const headList = data.filter(item => item[sortFieldId] !== '--' && item[sortFieldId] !== '-') || []
          if (sortMethod) {
            return [...orderBy(headList, [`_${sortFieldId}`], [sortMethod]), ...rearList];
          } else {
            return data;
          }
        },
      }
    }) : []
  }
  return {
    fields: fields,
    meta: props.isDataCenter ? meta : props.dataChart.meta,
    data: data.value,
    sortParams,
  };
});
let refresh = ref(false);

const resetDataByRule = async (list) => {
  const {
    styleConditionData = []
  } = props.schema.prop
  const globalRule = styleConditionData.find(item => item.scope === 'all')
  let promiseList = []
  let res = deepClone(list)
  let globalMatchStyle = {}
  let globalMatch = false
  // 全局样式
  if (globalRule) {
    list.forEach((item, listIndex) => {
      promiseList.push(util.parseSignRule(globalRule.conditions, item, (type) => {
        if (type === 'match') {
          globalMatch = true
          globalMatchStyle = {
            bgColor: globalRule.bgColor,
            fontColor: globalRule.fontColor,
            fontSize: globalRule.fontSize,
            fontWeight: globalRule.fontWeight,
          }
        }
      }))
    })
  }
  await Promise.all(promiseList)
  if (globalMatch) {
    res = res.map(item => {
      return {
        ...item,
        _globalMatchStyle: globalMatchStyle
      }
    })
  }
  // 全局样式处理完，处理非全局样式
  promiseList = []
  const matchIndexList = []
  list.forEach((item, listIndex) => {
    styleConditionData.forEach(ruleItem => {
      // 取第一条规则的字段作为当前作用字段
      const matchFieldCode = ruleItem.conditions?.rows[0]?.fieldMap?.code
      if (ruleItem.scope === 'current') {
        promiseList.push(util.parseSignRule(ruleItem.conditions, item, (type) => {
          if (type === 'match') {
            matchIndexList.push({
              matchIndex: listIndex,
              code: matchFieldCode,
              bgColor: ruleItem.bgColor,
              fontColor: ruleItem.fontColor,
              fontSize: ruleItem.fontSize,
              fontWeight: ruleItem.fontWeight,
            })
          }
        }))
      }
    })
  })
  await Promise.all(promiseList)
  matchIndexList.forEach(item => {
    const {_style = []} = res[item.matchIndex]
    if (!_style.find(styleItem => styleItem.code === item.code)) {
      _style.push(item)
    }
    res.splice(item.matchIndex, 1, {
      ...res[item.matchIndex],
      _style,
    })
  })
  return res
}

async function handlerRes() {
  let list
  if (!props.isDataCenter) {
    list = props?.dataChart?.list || []
  } else {
    list = props.dataChart;
  }
  list = await resetDataByRule(list)
  list = resetDataBySheetChart(list)
  data.value = list;
  initChart();
}

function resetDataBySheetChart(list) {
  const {
    sheetChartData = []
  } = props.schema.prop
  let data = list.map(item => {
    let obj = {}
    sheetChartData.forEach(chartItem => {
      const fieldCode = chartItem.field.code
      if (item[`_${fieldCode}`] !== undefined && chartItem.chartClass === 'progress') {
        obj[`${fieldCode}`] = {
          // 子弹图
          values: {
            type: 'bullet',
            measure: item[`_${fieldCode}`],
          },
        }
      }
    })
    return {
      ...item,
      ...obj,
    }
  })
  return data
}

class CustomTooltip extends BaseTooltip {
  constructor(spreadsheet) {
    super(spreadsheet);
  }

  renderContent() {
    const cell = this.spreadsheet.getCell(this.options.event?.target);
    const meta = cell?.getMeta();
    const tooltipVNode = createVNode(SheetTooltip, {meta});
    render(tooltipVNode, this.container);
  }
}

const calcIconStyle = (rank, style) => {
  const themeCellFontSize = (themeConfig.value?.sheetSet?.cellContent?.size || 12)
  const dataFontSize = props.schema.prop?.theme?.dataCell?.text?.fontSize || themeCellFontSize
  const {
    x,
    y,
    width,
    height,
  } = style
  const defaultStyle = {
    width: (dataFontSize + 1) * 2,
    height: (dataFontSize + 1) * 2,
    x: x + width * 0.5 - (dataFontSize + 1),
    y: y + height * 0.5 - (dataFontSize + 1),
  }
  switch (rank) {
    case 1:
      return {
        ...defaultStyle,
        src: rank1Icon,
      };
    case 2:
      return {
        ...defaultStyle,
        src: rank2Icon,
      };
    case 3:
      return {
        ...defaultStyle,
        src: rank3Icon,
      };
    default :
      return {
        width: dataFontSize * 2,
        height: dataFontSize * 2,
        x: x + width * 0.5 - dataFontSize,
        y: y + height * 0.5 - dataFontSize,
        src: rank4Icon,
      };
  }
}

class CustomColCell extends ColCell {
  getTextStyle() {
    let suStyle = super.getTextStyle()
    const {
      valueField,
      colQuery,
      rowQuery,
      rowIndex,
      fieldValue,
    } = this.meta
    let metaData = this.meta.data
    const defaultTextStyle = super.getTextStyle();
    if (isBasic.value === false) { // 基础表
      metaData = data.value[rowIndex]
    }
    if (valueField === "$$series_number$$" && props.schema.prop?.config?.rankFlag) {
      if (fieldValue < 4) {
        return {
          ...defaultTextStyle,
          textAlign: 'center',
          opacity: 0,
        }
      }
      return {
        ...defaultTextStyle,
        textAlign: 'center',
        zIndex: 20,
      }
    }
    if (metaData?._style && metaData?._style?.find(styleItem => styleItem.code === valueField)) {
      const matchStyle = metaData?._style?.find(styleItem => styleItem.code === valueField)
      return {
        ...defaultTextStyle,
        fontSize: matchStyle?.fontSize || 14,
        fill: matchStyle?.fontColor,
        fontWeight: matchStyle?.fontWeight,
        linkTextFill: suStyle.linkTextFill ? matchStyle?.fontColor : ''
      }
    } else if (metaData?._globalMatchStyle) {
      return {
        ...defaultTextStyle,
        fontSize: metaData?._globalMatchStyle?.fontSize || 14,
        fill: metaData?._globalMatchStyle?.fontColor,
        fontWeight: metaData?._globalMatchStyle?.fontWeight,
        linkTextFill: suStyle.linkTextFill ? metaData?._globalMatchStyle?.fontColor : ''
      }
    }
    // 使用默认处理
    suStyle.linkTextFill = suStyle.fill
    return suStyle;

  }
}

class CustomDataCell extends DataCell {

  drawBackgroundShape() {
    const {
      valueField,
      fieldValue,
      x,
      y,
      width,
      height,
    } = this.meta
    if (valueField === "$$series_number$$" && props.schema.prop?.config?.rankFlag) {
      const calcStyle = calcIconStyle(fieldValue, {x, y, width, height})
      this.backgroundShape = this.appendChild(
          new GImage({
            style: {
              ...this.getBBoxByType(),
              ...calcStyle,
              zIndex: 10,
            },
          }),
      );
    }
    return super.drawBackgroundShape();
  }

  drawTextShape() {
    if (this.isMultiData()) {
      return drawCustomContent(this);
    }
    super.drawTextShape();
  }

  getBackgroundColor() {
    const {
      valueField,
      colQuery,
      rowQuery,
      rowIndex,
    } = this.meta
    let metaData = this.meta.data
    // 特定数据
    if (isBasic.value === false) { // 基础表
      metaData = data.value[rowIndex]
    }
    if (metaData?._style && metaData?._style?.find(styleItem => styleItem.code === valueField)) {
      const matchStyle = metaData?._style?.find(styleItem => styleItem.code === valueField)
      return {
        backgroundColor: matchStyle?.bgColor,
        backgroundColorOpacity: 1,
      }
    } else if (metaData?._globalMatchStyle) {
      return {
        backgroundColor: metaData?._globalMatchStyle?.bgColor,
        backgroundColorOpacity: 1,
      }
    }

    return super.getBackgroundColor();
  }

  getTextStyle() {
    let suStyle = super.getTextStyle()
    const {
      valueField,
      colQuery,
      rowQuery,
      rowIndex,
      fieldValue,
    } = this.meta
    let metaData = this.meta.data
    const defaultTextStyle = super.getTextStyle();
    if (isBasic.value === false) { // 基础表
      metaData = data.value[rowIndex]
    }
    if (valueField === "$$series_number$$" && props.schema.prop?.config?.rankFlag) {
      if (fieldValue < 4) {
        return {
          ...defaultTextStyle,
          textAlign: 'center',
          opacity: 0,
        }
      }
      return {
        ...defaultTextStyle,
        textAlign: 'center',
        zIndex: 20,
      }
    }
    if (metaData?._style && metaData?._style?.find(styleItem => styleItem.code === valueField)) {
      const matchStyle = metaData?._style?.find(styleItem => styleItem.code === valueField)
      return {
        ...defaultTextStyle,
        fontSize: matchStyle?.fontSize || 14,
        fill: matchStyle?.fontColor,
        fontWeight: matchStyle?.fontWeight,
        linkTextFill: suStyle.linkTextFill ? matchStyle?.fontColor : ''
      }
    } else if (metaData?._globalMatchStyle) {
      return {
        ...defaultTextStyle,
        fontSize: metaData?._globalMatchStyle?.fontSize || 14,
        fill: metaData?._globalMatchStyle?.fontColor,
        fontWeight: metaData?._globalMatchStyle?.fontWeight,
        linkTextFill: suStyle.linkTextFill ? metaData?._globalMatchStyle?.fontColor : ''
      }
    }
    // 使用默认处理
    suStyle.linkTextFill = suStyle.fill
    return suStyle;

  }

}

function initChart() {
  if (!container.value) return;
  let w = props.schema?.styles?.width;
  let h = props.schema?.styles?.height;
  nextTick(() => {
    let bgList = []
    if (props.schema.prop?.metrics) {
      bgList = props.schema.prop.metrics?.filter(
          (el) => el?.set?.isWarn === 1
      );
    }
    let _option = {
      transformCanvasConfig() {
        return {
          supportsCSSTransform: true,
          devicePixelRatio: 2
        };
      },
      showDefaultHeaderActionIcon: !props.schema.prop?.config?.hideOrder,
      totals: {
        row: {
          showGrandTotals: props.schema.prop?.totals?.row?.showGrandTotals,
          calcGrandTotals: {
            // 设置总计汇总计算方式为求和
            aggregation: 'SUM',
          },
        },
        col: {
          showGrandTotals: props.schema.prop?.totals?.col?.showGrandTotals,
          calcGrandTotals: {
            // 设置总计汇总计算方式为求和
            aggregation: 'SUM',
          },
          // 总计分组下，city 城市维度会出现分组
        },
      },
      ...props.schema.prop.config,
      frozen: {
        rowCount: props.schema.prop.config.frozenRowCount,
        colCount: props.schema.prop.config.frozenColCount
      },
      seriesNumber: {
        enable: props.schema.prop.config.showSeriesNumber
      },
      dataCell: (viewMeta, spreadsheet) => {
        return new CustomDataCell(viewMeta, spreadsheet);
      },
      colCell: (node, s2, headConfig) => {
        return new CustomColCell(node, s2, headConfig);
      },
      placeholder: {
        empty: {
          icon: 'Empty',
          description: '暂无数据'
        }
      }
    };
    if (props?.thisArg?.width) {
      _option.width = props.thisArg.width
    }
    if (props?.thisArg?.height) {
      _option.height = props.thisArg.height
    }
    let __option = cloneDeep(_option)
    let style = cloneDeep(__option.style)
    const themeCellLineHeight = themeConfig.value?.sheetSet?.cellLineHeight;
    const themeHeadLineHeight = themeConfig.value?.sheetSet?.headLineHeight;
    delete __option.style.rowCfg
    delete __option.style.colCfg
    delete __option.style.cellCfg
    __option.style.rowCell = {
      ...style.rowCfg,
    }
    __option.style.colCell = {
      ...style.colCfg,
      height: (style.colCfg.height || (themeHeadLineHeight?.size || undefined)),
      widthByField: getColumnWidth()
    }
    __option.style.dataCell = {
      ...style.cellCfg,
      height: (style.cellCfg.height || (themeCellLineHeight?.size || undefined))
    }

    // 动态高度设置获取
    if (props.schema.prop?.autoHeight) {
      // config.style.colCfg.height // 列高
      // config.style.rowCfg.height // 行高
      const maxHeight = (props.schema.prop.config?.style?.colCfg?.height || 35) + (props.schema.prop.config?.style?.rowCfg?.height || 30) * (props.schema.prop?.autoLineNumber || 3)
      __option.height = maxHeight
    }
    // 隐藏表头
    // __option.style.colCell = {
    //   height: 0,
    // }
    // tooltip: {
    //   operation: {
    //     hiddenColumns: false,
    //   }
    // },
    let linkFields = []
    if (props.schema.prop?.jumpActions?.length) {
      props.schema.prop?.jumpActions.forEach((el) => {
        el.fieldList.forEach(_el => {
          linkFields.push(_el.code)
        })
      })
    }
    __option.interaction = {
      linkFields: linkFields
    }
    if (props.schema.prop?.config.frozenTable) {
      __option.tooltip = {
        // enable: false,
        operation: {
          hiddenColumns: false,
        }

      }
      __option.interaction.selectedCellsSpotlight = false
      __option.interaction.hoverHighlight = false
      __option.interaction.brushSelection = false
    }
    options.value = __option

  });
  // 刷新图表
  refresh.value = true
  nextTick(() => {
    // refresh.value = false
    setTimeout(() => {
      refresh.value = false
    }, 1000);
  })
}

function getColumnWidth() {
  const res = {}
  props.schema.prop?.columns?.forEach((el) => {
    if (el?.set?.columnWidth) {
      res[el.code] = el?.set?.columnWidth
    }
  })
  return res
}

// function setTheme() {
//   debugger
//   sheet.value.instance.setThemeCfg({
//     name: 'dark',
//   });
// }

onMounted(() => {
  // fetchData();
});
const debouncedFn = useDebounceFn(() => {
  initChart();
}, 200);
//  动态刷新图表
// useEventListener(window, "resize", debouncedFn);

function getRect() {
  let rect = container.value.getBoundingClientRect();
  return rect;
}


defineExpose({
  handlerRes,
});
</script>
<style lang="scss" scoped>
.spreadsheet {
  width: 100%;
  height: fit-content;
  position: relative;
}
</style>
<style>
.antv-s2-tooltip-container {
  z-index: 20000 !important;
}
</style>
